import type {
  AllocationMechanism,
  SuperBundleAllocationsSortBy,
  SuperBundleCurrency,
  SuperBundleOfferStatus,
  SuperBundleQuantityUnit,
} from 'src/apis/super-bundle-service/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const superBundleQuantityUnitLabels: Record<
  SuperBundleQuantityUnit,
  string
> = {
  MWH_PER_HOUR: 'MWh/h',
  MWH_PER_DAY: 'MWh/d',
  KWH_PER_HOUR: 'kWh/h',
  KWH_PER_DAY: 'kWh/d',
};

export const superBundleQuantityUnitOptions = labelsToOptions(
  superBundleQuantityUnitLabels
);
export const superBundleQuantityUnitValues = labelsToValues(
  superBundleQuantityUnitLabels
);

export const superBundleCurrencyLabels: Record<SuperBundleCurrency, string> = {
  EUR: 'EUR',
  RON: 'RON',
  BGN: 'BGN',
};

export const superBundleCurrencyOptions = labelsToOptions(
  superBundleCurrencyLabels
);
export const superBundleCurrencyValues = labelsToValues(
  superBundleCurrencyLabels
);

export const superBundleAllocationMechanismLabels: Record<
  AllocationMechanism,
  string
> = {
  UNIFORM_PRICE: 'Uniform Price',
};

export const superBundleOfferStatusLabels: Record<
  SuperBundleOfferStatus,
  string
> = {
  CREATED: 'Created',
  DELETED: 'Deleted',
  FAILED: 'Failed',
  PUBLISHED: 'Published',
  OPEN: 'Open',
  FINISHED: 'Finished',
  CANCELLED: 'Cancelled',
};

export const superBundleAllocationsSortByValues = [
  'OFFER_NAME',
  'SERVICE_RUNTIME_START',
  'SERVICE_RUNTIME_END',
  'PRICE',
  'QUANTITY',
] as const satisfies readonly SuperBundleAllocationsSortBy[];
